/* ***** ----------------------------------------------- ***** **
** ***** Main JS
** ***** ----------------------------------------------- ***** */


var Main = {
	modules: {}
};

/* global jQuery */
(function($){
	'use strict';

	Main.init = function() {
		// For each module in Main, call the init function
		$.each(Main.modules, function(moduleName, moduleFunction) {
			if ($.isFunction(moduleFunction().init())) {
				moduleFunction().init();
			}
		});
	};

	/* Vars */
	var $body = $('body');

	/* Init */
	$(function(){
		Main.init();
	});

	/* Scroll */
    $(window).scroll(function(){

		Main.modules.header().fixedHeader();
		Main.modules.lazyLoad().lazyLoad();

		if ($body.hasClass('single-post')) {
			Main.modules.header().fixedMetadataRow();
		}

	});

    /* Resize */
	$(window).resize(function(){

		Main.modules.lazyLoad().lazyLoad();

		if ($body.hasClass('home')) {
			Main.modules.flexslider().calculateHomeFeaturedMainSliderNavTop();
			Main.modules.flexslider().homeFeaturedMainSliderSetHeight();
		} else if ($body.hasClass('category-news')) {
			Main.modules.post().featuredMainNewsArticleSetHeight();
		} else if ($body.hasClass('single-post')) {
			Main.modules.header().fixedMetadataRow();
		}

	});

})(jQuery);
